import React, {useEffect, useState} from 'react'
import map_pin from '../assets/images/map_red.png';
import { plant_options } from '../constants/constVariables';
import { useDispatch, useSelector } from "react-redux";
import { FilterlistVins } from "../redux/actions/vinsAction"
// import { filterPlantName } from "../redux/actions/plantsAction"
import { plantData } from "../utils/apiServices"
import { getPlantValue } from '../constants/Utils'

export default function Dropdown(props) {
    const dispatch = useDispatch();
    const [dropdownOptionValue ,setdropdownOptionValue] = useState([]);
    const filterPlantName = getPlantValue();

    const mainDropdown = async (value) => {
        // console.log("Value}}}",value)
        //dispatch(filterPlantName(value));
        // const response = await filterVinsApi(value);plant_name
        
        // window.localStorage.setItem('PLANT_FILTER_NAME', value);
        // if (response?.data?.data?.vehicle_detail) {
        //     dispatch(FilterlistVins(response.data.data.vehicle_detail));
        // }
        // else {
        //     dispatch(FilterlistVins([]));
        // }
    };

    const plantValue = async () =>{
        const response = await plantData(filterPlantName.value);
        if(response?.data?.data){
             setdropdownOptionValue(response.data.data)
        }
    }
    useEffect(() => { plantValue(); }, ['']);

    return (
        <>
            <div className={`dashboard-main-dropdown-navbar ${props.hidden ? "hidden" : null}`}>
                <img src={map_pin} alt="map-marker" />
                <select className='dropdown-main mediumFont' onChange={(e) => mainDropdown(e.target.value)} defaultValue={"India"}                                >
                <><option value="all">India</option></>
                    {
                       
                        dropdownOptionValue.map((option, index) => {
                            return (
                                <option key={index} value={option.id}>{option.name}</option>
                            )

                        })

                    }
                </select>
            </div>
        </>
    )
}